import { ComplexValue, Value } from 'app/types-shared';
import { SelectItem } from 'ui/common/select/types';
import { Filter } from 'app/components/filters/types';

export interface FilterList {
  filter: Filter;
  selectedOptions: SelectItem[];
  key: string;
}

export interface AdvancedSearchOption extends ComplexValue<number>{
  advancedSearchType: number; 
  conditionOperator2?: Value;
  exactLevel?: boolean;
  searchRequired?: boolean;
}

export interface FilterReplacementsOption extends AdvancedSearchOption{
  isFilterReplacements?: boolean;
}


export interface PreDefDateResult {
  date: string;
}

export enum FilterOptionType {
  MENU_OPTION,
  OPTION_TYPE,
  SUB_OPTION_TYPE
}
